import Toash from "./components/toash";

class Anchor {
  constructor() {
    this.anchorEls = document.querySelectorAll(".jsAnchor");
    this.top = 80;
    this.init();
  }

  init() {
    if (this.anchorEls.length > 0) {
      this.anchorEls.forEach((anchorEl) => {
        anchorEl.addEventListener(
          "click",
          this.anchorClick.bind(this, anchorEl)
        );
      });
    }
    this.hash = window.location.hash;
    if (this.hash) {
      let anchorTargetEl = document.getElementById(this.hash.replace("#", ""));
      this.move(anchorTargetEl, "init");
    }
  }

  move(el, state) {
    if (state === "init") {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        0
      );
    }
    $("html, body").animate(
      {
        scrollTop: el.offsetTop - this.top,
      },
      500
    );
  }

  anchorClick(el, e) {
    let anchorTargetEl = document.getElementById(el.dataset.anchor);
    if (anchorTargetEl) {
      this.move(anchorTargetEl, "click");
      e.preventDefault();
    }
  }
}

class SendEmail {
  constructor() {
    this.btnSubmitEl = document.getElementById("jsSubmit");
    this.nameEl = document.getElementById("jsName");
    this.telEl = document.getElementById("jsTel");
    this.emailEl = document.getElementById("jsEmail");
    this.msgEl = document.getElementById("jsMsg");
    this.txtEl = document.getElementById("jsTxt");
    this.regexEmail =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    this.toash = new Toash("jsToash");
    this.init();
  }

  init() {
    if (this.btnSubmitEl) {
      this.btnSubmitEl.addEventListener("click", (e) => {
        this.txtEl.innerHTML = "";
        const token = turnstile.getResponse();
        if (
          this.nameEl.value === "" ||
          this.emailEl.value === "" ||
          this.telEl.value === "" ||
          this.msgEl.value === ""
        ) {
          this.toash.show("Vui lòng điền đầy đủ thông tin!", "error");
        } else if (!this.emailEl.value.match(this.regexEmail)) {
          this.toash.show("Email không đúng định dạng!", "error");
        }else if (!token) {
          this.toash.show("Vui lòng xác thực captcha!", "error");
        } else {
          this.btnSubmitEl.dataset.state = "sending";
          this.send(token);
        }
        e.preventDefault();
      });
    }
  }

  send(token) {
    let url = "https://hemail.htemplate.com/Email/send",
    data = {
      name: this.nameEl.value,
      tel: this.telEl.value,
      email: this.emailEl.value,
      msg: this.msgEl.value,
      website: location.hostname,
      to: "viettelngphilong@gmail.com",
      token: token
    },
    options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(url, options)
      .then(async (res) => {
        const result = await res.json();
        if (!res.ok) {
          throw result;
        }
        if (result.response === "1") {
          this.nameEl.value = "";
          this.emailEl.value = "";
          this.msgEl.value = "";
          this.telEl.value = "";
          this.toash.show("Gửi email thành công!", "success");
          this.txtEl.innerHTML = "Cảm ơn bạn đã gửi liên hệ<br>Chúng tôi sẽ liên hệ bạn trong thời gian sớm nhất!";
          this.btnSubmitEl.dataset.state = "success";
          turnstile.reset();
        } else {
          throw result;
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        let message = "Gửi thất bại, vui lòng thử lại!";
        if (error?.response === "captcha_error") {
          message = "Xác thực captcha thất bại!";
          turnstile.reset();
        }

        this.toash.show(message, "error");
        this.btnSubmitEl.dataset.state = "error";
      });
  }
}

class Tab {
  constructor(ttlClass, contentClass, tabBoxClass) {
    this.tabTtlEls = document.querySelectorAll(ttlClass);
    this.tabContentEls = document.querySelectorAll(contentClass);
    this.tabTtlEls.forEach(el => {
      el.addEventListener('click', () => {
        const tabCurrentEl = document.getElementById(el.dataset.tab);
        const tabBoxEl = el.closest(tabBoxClass);
        const tablTtlEls = tabBoxEl.querySelectorAll(ttlClass);
        const tablContentEls = tabBoxEl.querySelectorAll(contentClass);
        tablTtlEls.forEach(el => el.classList.remove('current'));
        tablContentEls.forEach(el => el.classList.remove('current'));
        el.classList.add('current');
        tabCurrentEl.classList.add('current');
      });
    });
  }
}

class Expand {
  constructor() {
    this.els = document.querySelectorAll('.jsExpand');
    this.els.forEach(el => {
      el.addEventListener("click", this.click.bind(this, el));
    });
  }

  click(el, e) {
    console.log(el, e);
    el.classList.toggle('expand');
  }
}

window.addEventListener("load", (e) => {
  new Anchor();
  new SendEmail();
  new Tab('.jsTabTtl', '.jsTabContent', '.jsTabBox');
  new Expand();

  particlesJS("jsParticles", {
    "particles": {
      "number": {
        "value": 100,
        "density": {
          "enable": true,
          "value_area": 800
        }
      },
      "color": {
        "value": "#ffffff"
      },
      "shape": {
        "type": ["image", "image1"],
        "stroke": {
          "width": 0,
          "color":
            "#000000"
        },
        "polygon": {
          "nb_sides": 5
        },
        "image": {
          "src": ["../assets/img/icon/i-wifi.webp", "../assets/img/icon/i-camera-ngoai-troi.webp", "../assets/img/icon/i-camera-trong-nha.webp", "../assets/img/icon/i-camera-trong-nha1.webp"],
          "width": 60,
          "height": 55
        }
      },
      "opacity": {
        "value": 0.5,
        "random": false,
        "anim": {
          "enable": false,
          "speed": 1,
          "opacity_min": 0.1,
          "sync": false
        }
      },
      "size": {
        "value": 10,
        "random": true,
        "anim": {
          "enable": false,
          "speed": 10,
          "size_min": 0.1,
          "sync": false
        }
      },
      "line_linked": {
        "enable": true,
        "distance": 150,
        "color": "#ffffff",
        "opacity": 0.4,
        "width": 1
      },
      "move": {
        "enable": true,
        "speed": 0.5,
        "direction": "none",
        "random": true,
        "straight": false,
        "out_mode": "out",
        "bounce": false,
        "attract": {
          "enable": false,
          "rotateX": 600,
          "rotateY": 1200
        }
      }
    },
    "interactivity": {
      "detect_on": "canvas",
      "events": {
        "onhover": {
          "enable": true,
          "mode": "repulse"
        },
        "onclick": {
          "enable": true,
          "mode": "push"
        },
        "resize": true
      },
      "modes": {
        "grab": {
          "distance": 400,
          "line_linked": {
            "opacity": 1
          }
        },
        "bubble": {
          "distance": 400,
          "size": 40,
          "duration": 2,
          "opacity": 8,
          "speed": 2
        },
        "repulse": {
          "distance": 200,
          "duration": 0.4
        },
        "push": {
          "particles_nb": 4
        },
        "remove": {
          "particles_nb": 2
        }
      }
    },
    "retina_detect": true
  });
});